import { createAppByPlatform } from '@/create-app/createAppIs24';
import { createAuth0Instance } from '@/helpers/Auth/authClient';
import { initDatadogRUM } from '@/helpers/RUMService/RUMService';
import { installHydrationMismatchCapture } from '@/helpers/vueHydrationReporting';
import App from './AppIs24.vue';
import scrollIntoView from './directives/scrollIntoView';

import('@smg-real-estate/acr-injection/umd');

(async () => {
  const { app, router, pinia } = await createAppByPlatform(App);

  app.directive('scroll-into-view', scrollIntoView);

  initDatadogRUM();
  installHydrationMismatchCapture();

  const piniaState = window.__PINIA_STATE__;
  if (piniaState) {
    pinia.state.value = piniaState;
  }

  const auth0 = createAuth0Instance();
  if (auth0) {
    app.use(auth0 as any);
  }

  await router.isReady();
  app.mount('#app');
})();
